const { registerBlockType } = wp.blocks;

const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, CheckboxControl } = wp.components;

registerBlockType(fontawesomeblock_data.suffix+'/font-awesome-block',{
	title:fontawesomeblock_data.lang.title,
	icon: 'format-image',
    category: 'widgets',
    className:'font-awesome-block',
    supports:{
        align:true,
        color:true
    },
    attributes:{
        iconName:{
            type:"string",
            default:"fas fa-headphones-alt"
        },
        big: {
            type:"boolean",
            default:false
        }
    },
	edit:(props)	=> {
        if(props.isSelected){
            return <Fragment>
                        <div>
                            <input 
                                onInput={(e)=>{
                                    props.setAttributes({iconName : e.target.value})
                                }}
                                value={props.attributes.iconName}
                            />
                            <i className={props.attributes.iconName + ' ' + props.className}></i>
                        </div>
                        <InspectorControls>
                            <PanelBody>
                                <h3>Options</h3>
                                <CheckboxControl
                                label="Agrandir l'icône"
                                checked={props.attributes.big}
                                onChange={val => {
                                    props.setAttributes({
                                        big:val
                                    })
                                }}
                            />
                            </PanelBody>
                        </InspectorControls>
                    </Fragment>
        }else{
            return  <i className={props.attributes.iconName + ' ' + props.className + (props.attributes.big?' bigger ':'')}></i>
        }
    },
    save:(props) 	=> {
        return  <i className={props.attributes.iconName + ' ' + props.className + (props.attributes.big?' bigger ':'')}></i>
    }, 
});

